var map = {
	"./1.svg": 379,
	"./2.svg": 380,
	"./3.svg": 381,
	"./4.svg": 382,
	"./courses/ai.png": 540,
	"./courses/computer_literacy.png": 541,
	"./courses/frontend.png": 542,
	"./courses/game_design.png": 543,
	"./courses/gamedev.png": 544,
	"./courses/graphic_design.png": 545,
	"./courses/main.png": 546,
	"./courses/predprinimatelstvo.png": 547,
	"./courses/programming_basics.png": 548,
	"./courses/python.png": 549,
	"./courses/scratch.png": 550,
	"./courses/unity.png": 551,
	"./courses/video_content.png": 552,
	"./courses/videoblogging.png": 553,
	"./courses/web-razrabotka.png": 554,
	"./courses/webdev.png": 555,
	"./coursesNew/ai.png": 428,
	"./coursesNew/computer_literacy.png": 429,
	"./coursesNew/ege-informatika-desk.png": 355,
	"./coursesNew/ege-informatika.png": 356,
	"./coursesNew/frontend.png": 430,
	"./coursesNew/game_design.png": 431,
	"./coursesNew/graphic_design.png": 432,
	"./coursesNew/math-desk.png": 357,
	"./coursesNew/math.png": 358,
	"./coursesNew/predprinimatelstvo.png": 433,
	"./coursesNew/programming_basics.png": 434,
	"./coursesNew/python.png": 435,
	"./coursesNew/scratch.png": 436,
	"./coursesNew/unity.png": 437,
	"./coursesNew/videoblogging.png": 438,
	"./coursesNew/web-razrabotka.png": 439,
	"./cube.svg": 556,
	"./cursor1.svg": 350,
	"./cursor2.svg": 351,
	"./cursor3.svg": 352,
	"./cursor4.svg": 353,
	"./enter.svg": 557,
	"./globe.svg": 558,
	"./outbreak.svg": 559,
	"./puzzle.svg": 560,
	"./story1.png": 561,
	"./story2.png": 562,
	"./story3.png": 563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 781;